import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ScrollShadow } from '@heroui/react';
import { menuGroups } from '../../../config/menuConfig.js';
import SidebarItem from './SidebarItem.jsx';
import { cn } from '../../../utils/cn.js';

const SidebarNav = ({ collapsed, onItemClick }) => {
    const [hoveredGroup, setHoveredGroup] = useState(null);

    const groupThemes = ['blue', 'purple', 'emerald', 'orange'];

    return (
        <ScrollShadow
            className="flex-1 px-3 py-4 overflow-y-auto overflow-x-hidden"
            hideScrollBar
            size={40}
        >
            <nav className="space-y-6">
                {menuGroups.map((group, index) => {
                    const currentTheme = groupThemes[index] || 'blue';

                    return (
                        <motion.div
                            key={group.title}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.05 }}
                            onMouseEnter={() => setHoveredGroup(index)}
                            onMouseLeave={() => setHoveredGroup(null)}
                        >
                            {/* Group Title (Only visible when expanded) */}
                            <AnimatePresence>
                                {!collapsed && (
                                    <motion.div
                                        initial={{ opacity: 0, height: 0, marginBottom: 0 }}
                                        animate={{ opacity: 1, height: 'auto', marginBottom: 8 }}
                                        exit={{ opacity: 0, height: 0, marginBottom: 0 }}
                                        className="px-3 flex items-center gap-2 overflow-hidden"
                                    >
                                        <motion.div
                                            className={cn(
                                                "w-1 h-4 rounded-full bg-gradient-to-b",
                                                group.gradient
                                            )}
                                            animate={{ height: hoveredGroup === index ? 16 : 12 }}
                                            transition={{ duration: 0.2 }}
                                        />
                                        <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                                            {group.title}
                                        </span>
                                    </motion.div>
                                )}
                            </AnimatePresence>

                            {/* Items */}
                            <div className="space-y-2">
                                {group.items.map((item) => (
                                    <SidebarItem
                                        key={item.path}
                                        item={item}
                                        collapsed={collapsed}
                                        onClick={onItemClick}
                                        theme={currentTheme}
                                    />
                                ))}
                            </div>

                            {/* Separator between groups (except last) */}
                            {index < menuGroups.length - 1 && (
                                <div className={cn(
                                    "mt-4 mx-2 h-px bg-slate-100 dark:bg-slate-800 transition-opacity duration-300",
                                    collapsed ? "opacity-100" : "opacity-0"
                                )} />
                            )}
                        </motion.div>
                    );
                })}
            </nav>
        </ScrollShadow>
    );
};

export default SidebarNav;
